import React from 'react';
import { useBrokerDetailsStore } from '../../../../state/brokerDetailsStore';
import { FileChooser } from '@apply/components';

export const W9FileUploadField: React.FC = () => {
    const updateFields = useBrokerDetailsStore((s) => s.updateFields);

    return (
        <>
            <h2 className='decorated'>W9 File</h2>
            <label htmlFor='w9File'>W9 File Uploaded:</label>
            <FileChooser
                id='w9File'
                dataTestid='w9File'
                handleChange={(e) => updateFields({ w9File: e.target.files?.[0] })}
            />
            <div className='w9-link-container'>
                <a
                    href='https://www.irs.gov/pub/irs-pdf/fw9.pdf'
                    target='_blank'
                    rel='noopener noreferrer'
                >
                    For a blank W9 follow this link
                </a>
            </div>
        </>
    );
};
